import React, { useEffect } from 'react'
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import config from '../../../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import { useRecoilValue } from 'recoil';
import { homeBannerState } from '../../../../recoil/states/default';
import { getHomeImageStorage } from '../../../../utils/localStorage';
import useHome from '../../context/useHome';

const MainBanner = (props) => {
    const { orgUnitId } = props
    const homeBanner = useRecoilValue(homeBannerState)
    const { setOrgUnitIdContext } = useHome()

    const ArrowLeft = ({ onClick, ...props }) => (
        <button
            className='slick-prev'
            onClick={onClick}
            aria-hidden="true"
            aria-disabled={false} >
            <FontAwesomeIcon
                icon={faCaretLeft} />
        </button>
    );
    const ArrowRight = ({ onClick, ...props }) => (
        <button
            className='slick-next'
            onClick={onClick}
            aria-hidden="true"
            aria-disabled={false} >
            <FontAwesomeIcon
                icon={faCaretRight} />
        </button>
    );

    const settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplaySpeed: 5000,
        prevArrow: <ArrowLeft />,
        nextArrow: <ArrowRight />,
    };

    useEffect(() => {
        fetchBanner()
    }, [homeBanner])

    const openImage = (url) => {
        window.open(url, '_blank')
    }

    const fetchBanner = () => {
        const homeImage = getHomeImageStorage()
        if (homeImage && homeImage.banner) {
            return homeImage.banner.map((item, index) => {
                return renderBanner(item, index)
            })
        } else {
            setOrgUnitIdContext(orgUnitId ?? '00')
            return <></>
        }
    }

    const renderBanner = (item, index) => {
        return (
            <div className='h-full' key={index}>
                <img className={`margin-auto h-full image-banner ${item.link ? 'cursor-pointer' : ''}`}
                    onClick={() => item.link ? openImage(`${item.link}`) : {}}
                    src={`${config.wfAttachFileEndPoint}/${item.banner}`}
                    alt={index} />
            </div>
        )
    }
    return (
        <div className='main-banner h-full'>
            <Slider {...settings} className='h-full flex items-center justify-center'>
                {fetchBanner()}
            </Slider>
        </div>
    )
}

export default MainBanner